/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */
import type {
  ClientDTO,
  ClientPatchRequest,
  CreateClientVm,
  DeleteClientPathParameters,
  GetAllClientsParams,
  GetClientPathParameters,
  PagedModelClientDTO,
  PartiallyUpdateClientPathParameters,
  SetIterableApiKeyPathParameters,
  UpdateClientIterableApiKeyVm,
  UpdateClientPathParameters,
} from "../schemas";

import { customInstance } from "../../config/mutator";

export const getClient = () => {
  /**
 * Get a client

Required authority: PERM_CLIENT_READ
 */
  const getClient = ({ id }: GetClientPathParameters) => {
    return customInstance<ClientDTO>({ url: `/api/clients/${id}`, method: "GET" });
  };
  /**
 * Update a client

Required authority: PERM_CLIENT_WRITE
 */
  const updateClient = ({ id }: UpdateClientPathParameters, clientDTO: ClientDTO) => {
    return customInstance<ClientDTO>({
      url: `/api/clients/${id}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: clientDTO,
    });
  };
  /**
 * Delete a client

Required authority: PERM_CLIENT_WRITE
 */
  const deleteClient = ({ id }: DeleteClientPathParameters) => {
    return customInstance<void>({ url: `/api/clients/${id}`, method: "DELETE" });
  };
  /**
 * Partially update a client

Required authority: PERM_CLIENT_WRITE
 */
  const partiallyUpdateClient = (
    { id }: PartiallyUpdateClientPathParameters,
    clientPatchRequest: ClientPatchRequest,
  ) => {
    return customInstance<ClientDTO>({
      url: `/api/clients/${id}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: clientPatchRequest,
    });
  };
  /**
 * Get a client

Required authority: PERM_CLIENT_ADVANCED
 */
  const setIterableApiKey = (
    { id }: SetIterableApiKeyPathParameters,
    updateClientIterableApiKeyVm: UpdateClientIterableApiKeyVm,
  ) => {
    return customInstance<ClientDTO>({
      url: `/api/clients/${id}/iterable-api-key`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateClientIterableApiKeyVm,
    });
  };
  /**
 * Get all clients

Required authority: PERM_CLIENT_READ
 */
  const getAllClients = (params?: GetAllClientsParams) => {
    return customInstance<PagedModelClientDTO>({ url: `/api/clients`, method: "GET", params });
  };
  /**
 * Create a client

Required authority: PERM_CLIENT_WRITE
 */
  const createClient = (createClientVm: CreateClientVm) => {
    return customInstance<ClientDTO>({
      url: `/api/clients`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createClientVm,
    });
  };
  return {
    getClient,
    updateClient,
    deleteClient,
    partiallyUpdateClient,
    setIterableApiKey,
    getAllClients,
    createClient,
  };
};
export type GetClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["getClient"]>>
>;
export type UpdateClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["updateClient"]>>
>;
export type DeleteClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["deleteClient"]>>
>;
export type PartiallyUpdateClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["partiallyUpdateClient"]>>
>;
export type SetIterableApiKeyResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["setIterableApiKey"]>>
>;
export type GetAllClientsResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["getAllClients"]>>
>;
export type CreateClientResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof getClient>["createClient"]>>
>;
